import { date, number as mecomNumber, withUnit } from "../../../assets/mecom/js/format.mjs";
import { coveredRange } from "./ncInternePeriods.mjs";

export const API = "/qualita/nc-interne/";
export function readNc(work, url, params = {}, controller = null, options = {}) {
    return work.get(url, params, true, controller, { ...options, rejectSilentErrors: true });
}
export const numeric = value => value === null || value === undefined || value === "" ? null : Number(value);
export const number = (value, decimals = 1, minimumDecimals = 0) => mecomNumber(numeric(value), decimals, minimumDecimals, "always");
export const euro = value => numeric(value) === null ? "n.d." : `${number(numeric(value), 2, 2)} €`;
export const qty = value => numeric(value) === null ? "—" : `${number(value)} pz`;
export const rate = value => withUnit(numeric(value), "%");
export { date };
export { periodForToday } from "./ncInternePeriods.mjs";
export function nextDay(value) {
    if (!validDate(value)) throw new Error("Data non valida.");
    const day = new Date(`${value}T12:00:00Z`);
    day.setUTCDate(day.getUTCDate() + 1);
    return day.toISOString().slice(0, 10);
}
export function annualHistoryRange(year, now = new Date()) {
    const start = `${year}-01-01`, yearEnd = `${Number(year) + 1}-01-01`;
    const today = new Intl.DateTimeFormat("sv-SE", { timeZone: "Europe/Rome" }).format(now);
    const throughToday = nextDay(today);
    return { start, end: throughToday < yearEnd ? throughToday : yearEnd };
}
export function validDate(value) {
    return typeof value === "string" && /^\d{4}-\d{2}-\d{2}$/.test(value)
        && !Number.isNaN(Date.parse(`${value}T12:00:00Z`))
        && new Date(`${value}T12:00:00Z`).toISOString().slice(0, 10) === value;
}
export function dateError(filters) {
    if (!validDate(filters.start) || !validDate(filters.until)) return "Inserisci due date valide.";
    if (filters.start > filters.until) return "La data iniziale deve precedere o coincidere con quella finale.";
    if ((Date.parse(filters.until) - Date.parse(filters.start)) / 86400000 >= 370) return "Seleziona un periodo di massimo 370 giorni.";
    return "";
}
export function initialFilters(now = new Date()) {
    const today = new Intl.DateTimeFormat("sv-SE", { timeZone: "Europe/Rome" }).format(now);
    return { start: `${today.slice(0, 7)}-01`, until: today, period_type: "month", calendar: "loss_event", date_basis: "known", q: "", phase: "", center: "", family: "", status: "consolidato", zero_only: false, ordering: "quantity", case_sort:"", origin:"", exclude_outliers:true };
}
export function queryFor(filters, page = 1, available = null) {
    const { until, ...query } = filters;
    for (const field of ["period_type", "period_year", "period_month", "period_quarter", "case_sort", "origin"]) delete query[field];
    const range = coveredRange(filters.start, nextDay(until), available);
    return { ...query, ...range, page, page_size: 25 };
}
export function errorMessage(error) {
    const data = error?.response?.data;
    if (typeof data?.detail === "string") return data.detail;
    if (data && typeof data === "object") return Object.entries(data).map(([key, value]) => `${key}: ${Array.isArray(value) ? value.join(" · ") : value}`).join(" · ");
    return "Impossibile completare la richiesta. Riprova.";
}
export function cacheKey(identity, query) {
    return `nc-interne:v7:${identity}:${JSON.stringify(query)}`;
}
export function withoutCachedValuations(value) {
    if (Array.isArray(value)) return value.map(withoutCachedValuations);
    if (value && typeof value === "object") return Object.fromEntries(Object.entries(value).map(([key, item]) => [key, ["valuation","known_total","value_eur","total_eur"].includes(key) ? null : withoutCachedValuations(item)]));
    return value;
}
export const stateLabels = { da_valutare: "Da valutare", in_analisi: "In analisi", fisiologico: "Fisiologico motivato",
    da_riconciliare: "Da riconciliare", da_rivalutare: "Da rivalutare", azione_definita: "Azione definita",
    verifica_efficacia: "Verifica efficacia", chiuso: "Chiuso", consolidato: "Consolidato", in_corso: "In corso", non_valutabile: "Da riconciliare", informativo: "Informativo" };
export const reasonLabels = { attivita_work_pendente: "Attività Work non ancora confermate", eccedenza_da_riconciliare: "Quantità a valle superiore all'ingresso",
    frazioni_o_percorso_ambiguo: "Percorso o frazioni da verificare", stato_saldo_incoerente: "Stato di saldo non coerente",
    consuntivi_non_quadrati: "Avanzamenti non coerenti con il totale fase", versamento_finale_eccedente: "Versamento finale superiore all'ultima fase",
    quantita_incoerenti: "Quantità incoerenti", versamento_finale_da_riconciliare: "Differenza nel versamento finale",
    scarti_dichiarati_non_quadrati: "Quantità scartate non coerenti con la differenza", fasi_assenti: "Ciclo senza fasi",
    storno_da_riconciliare: "Sono presenti storni", qualita_da_valutare: "Quantità in attesa di valutazione qualità",
    prodotto_principale_non_univoco: "Prodotto principale non identificato in modo univoco", prodotto_annullato: "Prodotto annullato",
    fase_produttiva_non_identificata: "Fase produttiva di origine da verificare", quantita_mancante: "Quantità mancante",
    quantita_non_valida: "Quantità non valida", avanzamenti_duplicati: "Documenti di avanzamento duplicati",
    quantita_avanzamento_non_valida: "Quantità di avanzamento mancante o non valida", unita_prodotto_da_riconciliare: "Unità del prodotto da verificare",
    unita_da_riconciliare: "Unità o coefficiente da verificare", contratto_scarti_da_verificare: "Significato della quantità scartata da verificare" };
